import { take, fork} from 'redux-saga/effects';
import {
  setRootPath,
} from '../actions/global';
// [redux-saga] ...非同期処理を取り扱う仕組み
// 関数を作成したらモジュールの最後尾 saga()にてFork する事。
// while(true) で待機状態を作る。
// yield take(`${actionName}`) に定義したアクション名を受け取ると発火する。
// アクション名は ../actions/{module_name}.js にて定義する。
// 発火させるには component にて this.props.dispatch(actionName());
// disaptchしたものは 戻り値.payloadで取り出せる。
// action関数の引数は sagaに渡される前に reducer/{module_name}.jsにて処理され
// stateの状態変更を行っている

export function* handleSetRootPath() {
  while (true) {
    yield take(`${setRootPath}`);

  }
}

//作った関数をまとめて form 関数名 saga() の変更は必要無し。
export default function* saga(){
  yield fork(handleSetRootPath);
}



// WEBPACK FOOTER //
// ./src/sagas/global.js